const modal ={
  cancelButton: 'Cancel',
  confirmButton: 'Confirm',
};

export default modal;
